import { Mail, Briefcase } from "lucide-react"
import { Card, CardContent } from "@/modules/shared/ui/components/card"

interface Props {
  firstName: string
  lastName: string
  email: string
  position: string
}

function getInitials(first: string, last: string) {
  return `${first.trim().slice(0, 1)}${last.trim().slice(0, 1)}`.toUpperCase()
}

function InfoRow({ icon, label, value }: { icon: React.ReactNode; label: string; value: React.ReactNode }) {
  return (
    <div className="flex items-start gap-3 py-3 border-b border-border last:border-0">
      <div className="text-muted-foreground mt-0.5 shrink-0">{icon}</div>
      <div className="flex-1 min-w-0">
        <p className="text-xs text-muted-foreground font-medium uppercase tracking-wide">{label}</p>
        <div className="text-sm text-foreground mt-0.5">{value}</div>
      </div>
    </div>
  )
}

export function OffboardingEmployeeCard({ firstName, lastName, email, position }: Props) {
  return (
    <Card className="bg-card border border-border">
      <CardContent className="p-6">
        <h2 className="text-base font-semibold text-foreground mb-4">Employee</h2>
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-14 bg-muted rounded-full flex items-center justify-center shrink-0">
            <span className="text-lg font-semibold text-foreground">{getInitials(firstName, lastName)}</span>
          </div>
          <div>
            <p className="text-lg font-semibold text-foreground">{firstName} {lastName}</p>
            <p className="text-sm text-muted-foreground">{position}</p>
          </div>
        </div>
        <InfoRow icon={<Mail className="w-4 h-4" />} label="Email" value={email} />
        <InfoRow icon={<Briefcase className="w-4 h-4" />} label="Position" value={position} />
      </CardContent>
    </Card>
  )
}
